module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand0-be430573407937605983d38be3a79b2a.jpg";